/*
createSessionID.js
创建生成一个sessionID,userID_时间戳(16进制)
 */

export const createSessionID = ({userID='point5'}) => {
    const timestamp = Date.now().toString(16);  // 当前时间戳转换为16进制
    const sessionID = userID + '_' + timestamp;
    return sessionID;
};